import { ReactNode, useState } from 'react'
import { PanelLeft } from 'lucide-react'
import Sidebar from './Sidebar'
import SearchBar from './SearchBar'
import UserMenu from './UserMenu'
import MatrixRain from './MatrixRain'
import { Button } from '@/components/ui/button'
import { useThemeStore } from '@/stores/themeStore'
import { useIncognito } from '@/hooks/use-incognito'
import { cn } from '@/lib/utils'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const theme = useThemeStore((state) => state.theme)
  const { isIncognito } = useIncognito()
  const [sidebarOpen, setSidebarOpen] = useState(true)

  return (
    <div className="flex h-screen overflow-hidden">
      {theme === 'matrix' && <MatrixRain />}
      <div className={cn('transition-all duration-300 overflow-hidden shrink-0', sidebarOpen ? 'w-64' : 'w-0')}>
        <Sidebar />
      </div>
      <div className="flex flex-1 flex-col overflow-hidden relative z-10">
        <header className="flex h-16 items-center border-b bg-muted/30 shrink-0">
          <div className="container mx-auto flex items-center px-6">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSidebarOpen((o) => !o)}
              aria-label="Toggle sidebar"
              className="mr-2 shrink-0"
            >
              <PanelLeft className="h-5 w-5" />
            </Button>
            <div className="flex-1" />
            {!isIncognito && <SearchBar />}
            <div className="flex-1 flex justify-end">
              <UserMenu />
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto bg-background">
          {theme === 'matrix' && (
            <div className="bg-primary/10 border-b border-primary/30 px-6 py-3">
              <p className="text-center text-sm font-mono text-primary">
                ⚡ This is a demo UI by gridX ⚡
              </p>
            </div>
          )}
          <div className="container mx-auto p-6">{children}</div>
        </main>
      </div>
    </div>
  )
}
